// Not under the `newsfeed` root: the feed's cache updates expect feed pages under that key.
export const PENDING_CONFIRMATIONS_QUERY_KEY = ['newsfeed-pending-confirmations'] as const;
export const POST_CONFIRMATIONS_QUERY_KEY = ['newsfeed-confirmations'] as const;
